import { useT } from "../../i18n";
import { Seitenkopf } from "../../bausteine/Handyformen";
import { heuteImBetrieb, wochentagVon } from "../../daten/betriebstag";

/* ══════════════════════════════════════════════════════════════════
   Der Kopf der beiden Einstiegsschirme — jetzt im Inhalt, nicht im
   Maskenkopf (18.09.2026, abends).

   ── Was er vorher war ──────────────────────────────────────────────

   Bis heute Mittag standen dort drei Auskünfte übereinander: „Heute" im
   Maskenkopf, darunter „Donnerstag, 17. September" in Versalien, und
   darunter noch einmal „Der Tag auf dem Hof". Luca, 17.09.2026: *„Heißt:
   Heute, dann steht da das Datum, der Tag auf dem Hof … das sieht wirklich
   nicht gut aus."* Daraus wurde **eine** Zeile im Maskenkopf: Name, Strich,
   „Fr 18.09." in Mono.

   ── Warum er jetzt in den Inhalt wandert ───────────────────────────

   Luca am Abend des 18.09.2026, mit der Handyfassung von OVIS als Vorbild:
   *„Kopier ruhig das Layout grundsätzlich ab. … Das sieht einfach deutlich
   besser aus."* Dort steht der Name der Fläche als **große Überschrift im
   Inhalt** und rollt mit weg; oben bleibt nur, was sich nie ändert
   (42-vorbild-ovis.md, Teil 2).

   Genau das ist dieser Schirm: Er hat keinen Rückweg, keinen Zusammenhang
   und keine Hauptaktion im Kopf — die Kopfzeile trug nur den Namen. Ohne
   `<Kopf>` bleibt das Portalziel leer und zeichnet nichts
   (`stile/telefon.css`); die Maske gewinnt rund 90 px, und der Name steht
   dort, wo man liest.

   **Das Datum steht ausgeschrieben.** „Fr 18.09." in Mono liest sich wie
   eine Kennung — etwas, das man vergleicht. Ein Tag, an dem man arbeitet,
   ist keiner: „Freitag, 18. September", leise, in der Schrift des
   Fließtexts. Das ist dieselbe Zeile, die das Vorbild unter „Start" führt.
   ══════════════════════════════════════════════════════════════════ */

export function Tageskopf({ titel }: { titel: string }) {
  const t = useT();
  // Heute in deutscher Zeit (N8-02); Montag ist der erste Tag der Woche.
  const heute = heuteImBetrieb();
  const [, monatNr = 1, tagNr = 1] = heute.split("-").map(Number);
  const wochentag = t.liste("kalender.wochentageLang")[wochentagVon(heute)] ?? "";
  const monat = t.liste("kalender.monate")[monatNr - 1] ?? "";

  return (
    <Seitenkopf
      titel={t(titel)}
      unter={t("handyHeute.tagLang", { wochentag, tag: tagNr, monat })}
    />
  );
}
